import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight as faAngleRightLight } from '@fortawesome/pro-light-svg-icons';
import { faPlusCircle as faPlusCircleRegular } from '@fortawesome/pro-regular-svg-icons';
library.add(faAngleRightLight, faPlusCircleRegular);
